import scratch01 from '../img/CentroInnovacion/scratch01.jpg';
import scratch02 from '../img/CentroInnovacion/scratch02.jpg';
import scratch03 from '../img/CentroInnovacion/scratch03.jpg';
import scratch04 from '../img/CentroInnovacion/scratch04.jpg';
import scratch05 from '../img/CentroInnovacion/scratch05.jpg';
import scratch06 from '../img/CentroInnovacion/scratch06.jpg';
import scratch07 from '../img/CentroInnovacion/scratch07.jpg';
import scratch08 from '../img/CentroInnovacion/scratch08.jpg';

const proyectos = [

{
    id: 1, 
    categoria: "Programación",
    titulo: "Creación de Animaciones",
    descripcion: "Los alumnos desarrollaron personajes, escenarios y efectos utilizando bloques de programación visual.",
    archivo: scratch01,
    link: ""
},

{
    id: 2,
    categoria: "Programación",
    titulo: "Introducción a Scratch",
    descripcion: "Nuestros estudiantes comenzaron a descubrir el mundo de la programación mediante el uso de Scratch, creando sus primeras animaciones y secuencias interactivas.",
    archivo: scratch02,
    link: ""
},

{
    id: 3,
   categoria: "Programación",
    titulo: "Primeros Videojuegos",
    descripcion: "Aplicando variables, movimientos y eventos, los estudiantes construyeron sus primeros videojuegos.",
    archivo: scratch03,
    link: ""
},

{
    id: 4,
    categoria: "Programación",
    titulo: "Primeros Videojuegos",
    descripcion: "Aplicando variables, movimientos y eventos, los estudiantes construyeron sus primeros videojuegos.",
    archivo: scratch04,
    link: ""
},

{
    id: 5,
    categoria: "Pensamiento Computacional",
    titulo: "Resolución de Problemas",
    descripcion: "Mediante desafíos de programación, los estudiantes fortalecen el pensamiento lógico y la resolución de problemas.",
    archivo: scratch05,
    link: ""
},

{
    id: 6,
    categoria: "Creatividad Digital",
    titulo: "Diseño de Proyectos",
    descripcion: "Cada estudiante desarrolla proyectos originales integrando creatividad, programación y trabajo colaborativo.",
    archivo: scratch06,
    link: ""
},

{
    id: 7,
    categoria: "Innovación",
    titulo: "Aprendiendo Programación",
    descripcion: "El Centro de Innovación promueve el desarrollo de habilidades digitales para enfrentar los desafíos del siglo XXI.",
    archivo: scratch07,
    link: ""
},

{
    id: 8,
    categoria: "Scratch",
    titulo: "Presentación de Proyectos",
    descripcion: "Los estudiantes presentan y comparten sus proyectos con la comunidad educativa, fortaleciendo la comunicación y el trabajo en equipo.",
    archivo: scratch08,
    link: ""
}

];

export default proyectos;